export default __webpack_public_path__ + "static/media/qrcode-imagem.ab467a74.svg";